import React from 'react';

// Styles & Assets
import styles from './PatientsCheckbox.module.css';

// Hooks
import { useState } from 'react';

// Components
import Searchbar from '../../UI/Searchbar/Searchbar';
import CheckboxButton from '../../UI/CheckboxButton/CheckboxButton';

// Interfaces
import { Patient } from '../../../interfaces/Patient';
interface PatientOptions {
    id: Patient['id']
    name: string
}
interface Props {
    patients: PatientOptions[];
    checkedPatients: number[];
    setCheckedPatients: React.Dispatch<React.SetStateAction<number[]>>;
}

const PatientsCheckbox: React.FC<Props> = ({ patients, checkedPatients, setCheckedPatients }) => {

    const [filterSearchbar, setFilterSearchbar] = useState<(patient: PatientOptions) => boolean>(() => () => true);

    const handleClickPatient = (patientID: Patient['id']) => (checked: boolean) => {
        setCheckedPatients(oldPatientIDs => checked ? [...oldPatientIDs, patientID] : oldPatientIDs.filter(id => id !== patientID))
    }

    const handleChangeSearchbar = (evt: React.ChangeEvent<HTMLInputElement>) => {
        setFilterSearchbar(() => (patient: PatientOptions) =>
            patient.name.toLowerCase().includes(evt.target.value.toLowerCase())
            || patient.id.toString().includes(evt.target.value)
        );
    };

    const patientsFiltered = patients.filter(p => filterSearchbar(p));

    return (
        <div className={styles.searchbarContainer}>
            <Searchbar handleChange={handleChangeSearchbar} />
            <div className={styles.patientsChecklistContainer}>
                {patientsFiltered.map(p =>
                    <CheckboxButton
                        key={p.id}
                        label={p.name}
                        onClick={handleClickPatient(p.id)}
                        checked={checkedPatients.includes(p.id)}
                    />
                )}
            </div>
        </div>
    );
};

export default PatientsCheckbox;